import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import { bool, func, number, shape, string } from "prop-types";

import * as S from "./styled";

const CalendarOption = ({
  createHref,
  handleAddToCalendar,
  icon,
  isSelfTarget,
  name,
  openHouseData,
  openHouseId
}) => {
  const href = createHref(openHouseData);

  const handleCalendarOptionClick = () => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "openhouse",
      event_action: "add_to_calendar",
      event_label: `${openHouseId}`
    });
    handleAddToCalendar();
  };

  return (
    <S.CalendarOptionContainer
      href={href}
      onClick={handleCalendarOptionClick}
      rel="nofollow"
      target={isSelfTarget ? "_self" : "_blank"}
    >
      <S.Icon className={`fa ${icon}`} />
      <Text className="add-to-calendar" type="sm">
        {name}
      </Text>
    </S.CalendarOptionContainer>
  );
};

CalendarOption.propTypes = {
  name: string.isRequired,
  icon: string.isRequired,
  handleAddToCalendar: func.isRequired,
  createHref: func.isRequired,
  openHouseData: shape({
    listingAddress: string,
    listingLink: string,
    time: shape({
      startsAt: string,
      endsAt: string
    }),
    streamingUrl: string
  }).isRequired,
  openHouseId: number.isRequired,
  isSelfTarget: bool
};

CalendarOption.defaultProps = {
  isSelfTarget: false
};

export default CalendarOption;
